import SolutionSummary from './SolutionSummary';

export default SolutionSummary;
